export default function FirmaComponente() {
    return {
        bindings: {
            firma: '=',
            firmaActualizada: "&"
        },
        template: require('./firma-componente.html'),
        controller: 'FirmaControlador as fc',
        controllerAs: true
    }
}